import { Pipe, PipeTransform } from '@angular/core';
import { prettyDate } from '../utils/helpers';
import moment from 'moment';

@Pipe({
    name: 'prettyDate',
    standalone: false
})
export class PrettyDatePipe implements PipeTransform {

  // transform(value?: string | Date | moment.Moment/* , ...args: unknown[] */): string | null {
  //   if (!value) return null;
  //   return prettyDate(value);
  // }

  // transform(value?: string | Date | moment.Moment): string | null {
  //   console.log('PrettyDatePipe Input Value:', value); // Log the input value
  //   if (!value) {
  //     console.log('PrettyDatePipe Output Value: null');
  //     return null;
  //   }
    
  //   const transformedValue = prettyDate(value);
  //   console.log('PrettyDatePipe Output Value:', transformedValue); // Log the transformed value
  //   return transformedValue;
  // }

  transform(value?: string | Date | moment.Moment): string | null {
    if (!value) {
      console.log('PrettyDatePipe Output Value: null');
      return null;
    }
    // Format the input and output date to DD/MM/YYYY
    const formattedDate = moment(value).format('DD/MM/YYYY');
    // console.log('PrettyDatePipe Input Value (Formatted):', formattedDate);
    // console.log('PrettyDatePipe Output Value:', formattedDate);
    return formattedDate;
  }

}
